import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Link from '../../../Link';
import { AppStoreButton, PlayStoreButton } from '../../../AppDownloadButtons';
import Img from '../../../Img';

import styles from './styles.sass';
import LinkStyles from '../../LinkStyles.sass';

import AnchorLogoSquareSVG from '../../../svgs/AnchorLogoSquare';
import Box from '../../../../shared/Box';
import Icon from '../../../../shared/Icon';
import Heading from '../../../../shared/Heading';
import Text from '../../../../shared/Text';

const NEW_PLATFORM_BUTTON_CAMPAIGN = 'Website-ProfilePage-2019-04-25';

const cx = classnames.bind(styles);

const renderLink = (isAndroidChrome, isIOS) => {
  if (isAndroidChrome) {
    return (
      <span key="appLinkContainer" className={styles.appButtonWrapper}>
        <PlayStoreButton height={38} campaign={NEW_PLATFORM_BUTTON_CAMPAIGN} />
      </span>
    );
  }
  if (isIOS) {
    return (
      <span key="appLinkContainer" className={styles.appButtonWrapper}>
        <AppStoreButton height={38} campaign={NEW_PLATFORM_BUTTON_CAMPAIGN} />
      </span>
    );
  }
  return (
    <div key="linksContainer" className={styles.linksContainer}>
      <Link className={LinkStyles.link} to="/switch">
        SWITCH TO ANCHOR
      </Link>
      <div className={styles.separator} />
      <Link className={LinkStyles.link} to="/signup">
        MAKE YOUR OWN PODCAST
      </Link>
    </div>
  );
};

const ProfilePageOverrideNav = ({ didMount, isAndroidChrome, isIOS }) => {
  // do not flash mobile/desktop before client is known (didMount)
  if (!didMount) {
    return <div className={styles.container} />;
  }
  if (isAndroidChrome || isIOS) {
    return (
      <div
        className={cx({
          container: true,
          containerWithMobileCTA: true,
        })}
      >
        <Box>
          <Box display="flex" alignItems="center">
            <Box width={15}>
              <Icon type="anchor_logo" fillColor="white" />
            </Box>
            <Box marginLeft={3}>
              <Heading size="xs" color="white" isBold>
                Anchor
              </Heading>
            </Box>
          </Box>
          <Box>
            <Text color="white" dangerouslySetFontSize={13}>
              Make your own podcast for free
            </Text>
          </Box>
        </Box>
        {renderLink(isAndroidChrome, isIOS)}
      </div>
    );
  }
  return (
    <div className={styles.container}>
      <a href="/" className={styles.logoLink}>
        <div className={styles.iconWrapper}>
          <AnchorLogoSquareSVG />
        </div>
        <Img
          src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-header.png"
          withRetina
          alt="Anchor logo"
          height={33}
          width={132}
          className={styles.logoImage}
        />
      </a>
      <p className={styles.profileNavText}>
        Make your own podcast for free with Anchor!
      </p>
      {renderLink(isAndroidChrome, isIOS)}
    </div>
  );
};

ProfilePageOverrideNav.defaultProps = {
  isAndroidChrome: false,
  isIOS: false,
};
ProfilePageOverrideNav.propTypes = {
  isAndroidChrome: PropTypes.bool,
  isIOS: PropTypes.bool,
};
export { ProfilePageOverrideNav };
